<template>
    <div class="activity_link_msg">
      <!--活动链接管理头部-->
      <div class="activity_link_msg_top">
        <div>
          <el-select v-model="selectStore" placeholder="请选择店铺">
            <el-option
              v-for="item in storeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <span>活动名称</span>
        <div>
          <input type="text" v-model="activityName" placeholder="活动名称">
        </div>
        <span>创建时间</span>
        <div class="w_percent11">
          <el-date-picker
            v-model.trim="startTime"
            type="datetime"
            placeholder="年/月/日"
            format="yyyy/MM/dd HH:mm:ss">
          </el-date-picker>
        </div>
        <div class="w_percent11">
          <el-date-picker
            v-model.trim="endTime"
            type="datetime"
            placeholder="年/月/日"
            format="yyyy/MM/dd HH:mm:ss">
          </el-date-picker>
        </div>

        <button class="btn_normal w116 ml5" @click="loadShopActivityPageList()">查询</button>
        <button class="btn_normal w116 ml5" @click="addActivity()">新增活动</button>
      </div>

      <!--活动链接管理列表-->
      <div class="activity_link_msg_list">
        <!--表格-->
        <table class="table">
          <thead>
          <tr>
            <th>活动名称</th>
            <th>店铺</th>
            <th>操作</th>
            <th>创建人</th>
            <th>创建时间</th>
          </tr>
          </thead>
          <tbody v-if="list.length">
          <tr v-for="(item, index) in list" :key="index">
            <td>{{item.ActivityName}}</td>
            <td>{{item.ShopName}}</td>
            <td>
              <a title="添加链接/货号" @click="addLinkOrGoods(item.ActivityId)">添加链接/货号</a>
              <a title="查看链接" @click="getLinkDetailsById(item)">查看链接</a>
              <a title="链接批量对接仓库" @click="batchSaveActivityStoreroomLinkDocking(item)">链接批量对接仓库</a>
              <a title="关闭/打开库存对接" @click="closeOrOpenTheInventoryConnection(item)">关闭/打开库存对接</a>
              <a title="按链接同步库存" @click="synceLinkStock(item)">按链接同步库存</a>
              <a title="查看货号" @click="getGoodsDetailsById(item)">查看货号</a>
              <a title="货号批量对接仓库" @click="batchSaveActivityStoreroomGoodsDocking(item)">货号批量对接仓库</a>
              <a title="查看同步日志" @click="loadActivityLogPageList(item)">查看同步日志</a>
            </td>
            <td>{{item.UserName}}</td>
            <td>{{item.CreateTime}}</td>
          </tr>
          </tbody>
          <tbody v-if="!list.length">
          <tr>
            <td colspan="8">暂时没有相关的数据</td>
          </tr>
          </tbody>
        </table>

        <!--分页-->
        <div v-if="list.length" class="text_right mt20">
          <el-pagination
            background
            :prev-text="'上一页'"
            :next-text="'下一页'"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>

      <!--弹出框-->
      <activity-link-embed v-if="isShow" :title="dialogTitle" :msg="msg"
                           :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></activity-link-embed>

      <!--提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeTipsDialog"></msg-dialog>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
    </div>
</template>

<script type="es6">
  import ActivityLinkEmbed from './activity-link-embed';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: "activity-link",
    components: {ActivityLinkEmbed,LoadingDialog, MsgDialog},
    data() {
      return {
        list: [],  // 列表
        storeList: [], // 店铺
        selectStore: '', // 选择的店铺
        activityName: null, // 活动名称
        startTime: this.Global.timeFormatStart(new Date(new Date() - 1000 * 60 * 60 * 24 * 15)), // 开始时间
        endTime: this.Global.timeFormatEnd(new Date()), // 结束时间
        isLoading: false, // 是否显示加载框isErrorTxt
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        isShow: false, // 提示框显示
        msg: null, // 父子组件互传的数据
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 20 // 总条数
      }
    },
    methods: {
      // 获取店铺下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg) {
            if (res.data.resData.length) {
              this.storeList = res.data.resData;
              this.selectStore = res.data.resData[0].Id;
            } else {
              this.storeList = res.data.resData;
              this.selectStore = '';
            }
            this.storeList.splice(0, 0, {id: '', text: '所有店铺'});
          } else {
            this.storeList = [];
            this.selectStore = res.data.errorMsg;
          }
        });
      },

      // 加载店铺活动页面列表
      loadShopActivityPageList() {
        // this.isLoading = true;
        const params = {
          ShopId: this.selectStore,
          UseStatus: 0,
          ActivityName: this.activityName,
          StartTime: this.Global.timeFormatEight(this.startTime),
          EndTime: this.Global.timeFormatEight(this.endTime),
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.LoadShopActivityPageList, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            if (res.data) {
              clearTimeout(timer);
              self.checkAll = false;
              self.checkboxModel = [];
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
                res.data.resData.DataList.forEach(function(item, index) {
                  self.checkboxModel.push(false);
                })
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        })
      },

      // 新增活动
      addActivity() {
        this.isShow = true;
        this.dialogShowType = 'addActivity';
        this.dialogTitle = '新增活动';
      },

      // 添加链接/货号
      addLinkOrGoods(id) {
        this.isShow = true;
        this.dialogShowType = 'addLinkOrGoods';
        this.dialogTitle = '添加链接/货号';
        this.msg = id;
      },

      // 链接批量对接仓库
      batchSaveActivityStoreroomLinkDocking(obj) {
        this.isShow = true;
        this.dialogShowType = 'batchSaveActivityStoreroomLinkDocking';
        this.dialogTitle = '链接批量对接仓库（配仓优先级不填写默认为0，为9时优先程度最低）';
        this.msg = obj;
      },

      // 关闭/打开库存对接
      closeOrOpenTheInventoryConnection(obj) {
        this.isShow = true;
        this.dialogShowType = 'closeOrOpenTheInventoryConnection';
        this.dialogTitle = '关闭/打开库存对接';
        this.msg = obj;
      },

      // 按链接同步库存
      synceLinkStock(obj) {
        this.isShow = true;
        this.dialogShowType = 'synceLinkStock';
        this.dialogTitle = '按链接同步库存';
        this.msg = obj;
      },

      // 查看链接
      getLinkDetailsById(obj) {
        this.isShow = true;
        this.dialogShowType = 'getLinkDetailsById';
        this.dialogTitle = '查看链接';
        this.msg = obj;
      },

      // 查看货号
      getGoodsDetailsById(obj) {
        this.isShow = true;
        this.dialogShowType = 'getGoodsDetailsById';
        this.dialogTitle = '查看货号';
        this.msg = obj;
      },

      // 货号批量对接仓库
      batchSaveActivityStoreroomGoodsDocking(obj) {
        this.isShow = true;
        this.dialogShowType = 'batchSaveActivityStoreroomGoodsDocking';
        this.dialogTitle = '货号批量对接仓库（配仓优先级不填写默认为0，为9时优先程度最低）';
        this.msg = obj;
      },

      // 查看同步日志数据
      loadActivityLogPageList(obj) {
        this.isShow = true;
        this.dialogShowType = 'loadActivityLogPageList';
        this.dialogTitle = '查看同步日志';
        this.msg = obj;
      },


      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        // console.log('操作成功后的信息1');
        // console.log(e);
        // console.log(this.showType);
        if (e.showType === 'addActivity') {
          this.loadShopActivityPageList();
        }
      },

      // 关闭提示框
      closeTipsDialog(e) {
        // console.log('操作成功后的信息2');
        // console.log(e);
        this.isMsg = e;
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadShopActivityPageList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadShopActivityPageList();
      }
    },
    created() {
      this.getAllPXShopList();
      this.loadShopActivityPageList();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .activity_link_msg {
    .activity_link_msg_top {
      & > div {
        max-width: 160px;
        margin-right: 5px;
      }

      .publish_btn {
        width: 125px;
      }
    }

    .activity_link_msg_list {

      td {
        a {
          display: inline-block;
          margin-right: 10px;
          &:last-child {
            margin-right: 5px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/activity-link.vue